export enum StatsGroupBy {
  'month' = 'month',
  'week' = 'week',
}
